var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfBigLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 57,
    viewBox: "0 0 50 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6957 0.709961C8.76322 0.709961 7.18213 2.29311 7.18213 4.22808V53.4817C7.18213 55.4167 8.76322 56.9998 10.6957 56.9998H45.8311C47.7635 56.9998 49.3446 55.4167 49.3446 53.4817V14.7824L35.2904 0.709961H10.6957Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8041 14.7824H49.3447L35.2905 0.709961V11.2643C35.2905 13.1993 36.8716 14.7824 38.8041 14.7824Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3443 25.3371L38.8037 14.7827H49.3443V25.3371Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3173 46.4459C42.3173 47.4133 41.5267 48.2049 40.5605 48.2049H1.91155C0.945331 48.2049 0.154785 47.4133 0.154785 46.4459V28.8553C0.154785 27.8878 0.945331 27.0962 1.91155 27.0962H40.5605C41.5267 27.0962 42.3173 27.8878 42.3173 28.8553V46.4459Z",
    fill: "#FF6E5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 34.0389C7.8125 33.5745 8.17791 33.0679 8.76643 33.0679H12.0112C13.8382 33.0679 15.4826 34.2922 15.4826 36.6388C15.4826 38.8622 13.8382 40.1006 12.0112 40.1006H9.66589V41.9582C9.66589 42.5773 9.27238 42.9274 8.76643 42.9274C8.30264 42.9274 7.8125 42.5773 7.8125 41.9582V34.0389ZM9.66589 34.8392V38.3433H12.0112C12.9528 38.3433 13.6977 37.5113 13.6977 36.6388C13.6977 35.6554 12.9528 34.8392 12.0112 34.8392H9.66589Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2339 42.9267C17.7701 42.9267 17.2642 42.6734 17.2642 42.056V34.0663C17.2642 33.5615 17.7701 33.1938 18.2339 33.1938H21.4505C27.8698 33.1938 27.7292 42.9267 21.577 42.9267H18.2339ZM19.1193 34.9107V41.2117H21.4505C25.2434 41.2117 25.4121 34.9107 21.4505 34.9107H19.1193Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.006 35.0241V37.2598H33.5881C34.094 37.2598 34.6 37.7664 34.6 38.2572C34.6 38.7216 34.094 39.1015 33.5881 39.1015H30.006V42.055C30.006 42.5475 29.6564 42.9257 29.1645 42.9257C28.5462 42.9257 28.1685 42.5475 28.1685 42.055V34.0654C28.1685 33.5605 28.5479 33.1929 29.1645 33.1929H34.0958C34.7142 33.1929 35.0796 33.5605 35.0796 34.0654C35.0796 34.5157 34.7142 35.0223 34.0958 35.0223H30.006V35.0241Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5608 48.2049H7.18213V49.964H40.5608C41.527 49.964 42.3175 49.1724 42.3175 48.2049V46.4458C42.3175 47.4133 41.527 48.2049 40.5608 48.2049Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfBigLogo);
export default __webpack_public_path__ + "static/media/pdfBigLogo.193794a46277b4a534eea783269df758.svg";
export { ForwardRef as ReactComponent };